import React from 'react';
import { motion } from "framer-motion";
import '../index.css';
import Spline from '@splinetool/react-spline';

const home = (props) => {
    return (
        <main className='container grid content-center h-screen mx-auto warna md:grid-cols-2'>

            {/* <motion.figure className='grid h-[300px] md:order-2 md:h-[400px]'
            >
                <Spline scene="https://prod.spline.design/vXiLrbOsghqPgJ6V/scene.splinecode" />
            </motion.figure> */}

            <iframe src='https://my.spline.design/cakecopy-0aed54e5db72eb54bf0f4d638a7e268b/' className='grid h-[300px] md:order-2 md:h-[400px] justify-self-center'></iframe>

            <div className='grid content-center text-center gap-4 px-4 h-full md:text-left md:px-12'>
                <motion.h1
                    className='font-marck text-5xl md:text-7xl'
                    initial={{ y: "100px", opacity: 0 }}
                    animate={{ y: 0, opacity: 0.8 }}
                    transition={{ duration: 1 }}>
                    {props.tes}
                </motion.h1>
                <motion.p
                    initial={{ y: "100px", opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 1, duration: 0.8 }}
                    className='font-indie text-sm md:text-lg'
                >For you who makes my life shine again</motion.p>

            </div>

        </main >
    )
}

export default home;

// 25 januari sasa birthday

